<template>
	<Col>
		<h5 class="section-title mb-1">Currently:</h5>
		<h5 class="mb-4">
			The {{ connectionNoun }} “{{ readableConnectionNames }}” {{ isMoreThanOneConnection ? 'are' : 'is' }} used for this step for everyone
			using the feature.
		</h5>
		<h5 class="section-title mb-1">{{ changeTitle }}</h5>
		<h5 class="mb-4">
			Every user will connect their own account, which will be used for this step when they use the feature. Only you will use “{{
				readableConnectionNames
			}}” when using this feature. (you can edit your {{ connectionNoun }} in your setup)
		</h5>
	</Col>
</template>

<script>
export default {
	name: 'NodeSuggestionContentDetails',
	props: { connectionNames: { type: Array }, didAcceptSuggestion: { type: Boolean } },
	computed: {
		readableConnectionNames() {
			return this.connectionNames.join(', ');
		},
		changeTitle() {
			return this.didAcceptSuggestion ? 'After the change:' : `If you'll accept the suggestion (choose 'Per user'):`;
		},
		isMoreThanOneConnection() {
			return this.connectionNames.length > 1;
		},
		connectionNoun() {
			return this.isMoreThanOneConnection ? 'connections' : 'connection';
		},
	},
};
</script>

<style lang="scss" scoped>
.section-title {
	color: #424242;
	font-weight: 600;
	letter-spacing: 0px;
}
</style>
